// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-78221318]{fill:#b1b1b1;stroke:#b1b1b1;stroke-width:.5px}", ""]);
// Exports
module.exports = exports;
